import styles from './Tile.module.scss'

const Empty = () => <div className={styles.empty} />

export default Empty
